var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-state"},[(_vm.isChecked)?[_c('p',{staticClass:"course-state course-state__active"},[_vm._v("Active")])]:[_c('p',{staticClass:"course-state course-state__draft"},[_vm._v("Draft")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }